import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebase/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { useSelector } from 'react-redux';

export const uploadImage = createAsyncThunk('fileUpload/images', async (image, thunkAPI) => {
  try {
    const storageRef = ref(storage, `images/${image.name}`);
    await uploadBytes(storageRef, image);
    const url = await getDownloadURL(storageRef);
    return url;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.message);
  }
});

const initialState = {
  loading: false,
  url: ''
};

export const fileUploadSlice = createSlice({
  name: 'fileUploads',
  initialState: initialState,
  reducers: {
    resetFileUpload() {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.loading = false;
        state.url = action.payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.loading = false;
        state.url = '';
      });
  }
});

export const { resetFileUpload } = fileUploadSlice.actions;
export default fileUploadSlice.reducer;
